import { render, staticRenderFns } from "./catalog-item-gap.vue?vue&type=template&id=fe22eae0&"
import script from "./catalog-item-gap.vue?vue&type=script&lang=js&"
export * from "./catalog-item-gap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PictureComponent: require('/var/www/components/picture/picture-component.vue').default})
